import {ApckPortletTable} from "../portlet";

export const ApckPortletActivityLogs = /*#__PURE__*/ ApckPortletTable.extend({
    props: {
        ctype: {
            type: String,
            default: "logsportlet"
        },
        title: {
            type: String,
            default: "Activity Logs"
        },
        size: {
            type: String,
            default: "lg"
        },
        description: {
            type: String,
            default: "A quick access table of recent logs"
        },
        src: {
            type: String,
            default: "/logs"
        },
        limit: {
            type: Number,
            default: 5
        },
        sglRowAction: {
            type: Function,
            default: function (rec) {
                window.open("/users/logs", '_blank').focus();
            },
        },
        cols: {
            type: Array,
            default: () => [
                {"heading": "Created", "ctype": "datecolumn", "data": "created", "canSearch": true, width: 157},
                {"heading": "Username", "ctype": "usercolumn", "data": "user_summary", "canSearch": true, width: 130},
                {"heading": "Event", "data": "description", "canSearch": true},
            ]
        }
    },
});
